import { useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";
import { ButtonDS, PendingActionsCard, PendingActionTask } from "@qivia/ui";
import { PendingTask } from "./tasksSummary";

export const PendingTasksCard = (props: {
  subject: string;
  tasks: PendingTask[];
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const basePath = location.pathname.split("/")[1];

  const pendingActionTasks: PendingActionTask[] = useMemo(
    () =>
      props.tasks.map((task) => {
        const Icon = task.icon;
        return {
          icon: (
            <StyledIcon $color={task.color}>
              <Icon />
            </StyledIcon>
          ),
          title: task.title,
          subtitle: task.subtitle,
          button: (
            <ButtonDS
              text={task.actionLabel}
              format={"hug"}
              buttonType={"secondary"}
              onClick={() => navigate(`/${basePath}/${task.targetPath}`)}
            />
          ),
        };
      }),
    [props.tasks, navigate, basePath],
  );

  return (
    <PendingActionsCard
      subject={props.subject}
      tasks={pendingActionTasks}
      maxWidth={40}
    />
  );
};

const StyledIcon = styled.div<{ $color: string }>`
  & svg {
    fill: ${({ $color }) => $color};
  }
`;
